/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AnalyticsModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { DiagramModule } from 'ng/modules/diagram/diagram.module';
import { FormsModule } from '@angular/forms';
import { LetModule } from '@ngrx/component';
import { SharedModule } from 'ng/shared/shared.module';

import {
    AnalyticsProfileListPageComponent,
    EndToEndComponent,
    EndToEndKnotComponent,
} from './components';

import { analyticsProfileCollectionProvider } from './ajs-upgraded-providers';
import { MsToStringPipe } from './pipes/ms-to-string.pipe';

const analyticsComponents = [
    AnalyticsProfileListPageComponent,
    EndToEndComponent,
    EndToEndKnotComponent,
];

const analyticsPipe = [
    MsToStringPipe,
];

/**
 * @description
 *      Angular Module for Analytics Profile related components.
 * @author Anjali Tanpure, Deepak Chaudhary
 */
@NgModule({
    declarations: [
        ...analyticsComponents,
        ...analyticsPipe,
    ],
    imports: [
        DataGridModule,
        DiagramModule,
        FormsModule,
        LetModule,
        SharedModule,
    ],
    providers: [
        analyticsProfileCollectionProvider,
    ],
    exports: [
        EndToEndComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AnalyticsModule {}
